import { IPoi, Poi } from '../poi/poi.model';
import { IThemes, Themes } from '../themes/themes.model';
import { IGeoPos, GeoPos } from '../geographicalpos/geographicalpos.model';
import { IAttachments, Attachments } from '../attachments/attachments.model';

export interface IItinState {
  current: IItin;
  filtered: Array<IItin>;
  ordered: Array<IItin>;
  list: Array<IItin>;
  total: number;
  page: number;
  size: number;
}

export interface IItin {
  id: any;
  itin_name?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  short_descr?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  description?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  trivia?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  attachments?: Array<IAttachments>;
  themes?: Array<IThemes>;
  geopos?: Array<IGeoPos>;
  views?: number;
  pois?: Array<IPoi>;
  approved?: boolean;
  expanded_panel: boolean;
  user_id?: number;
}

export const ITIN_STATE = {
  current: null,
  filtered: [],
  ordered: [],
  list: [],
  total: 0,
  size: 0,
  page: 0
};

export class Itin implements IItin {
  id: any;
  itin_name?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  short_descr?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  description?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  trivia?: {
    it?: string;
    sl?: string;
    en?: string;
  };
  attachments?: Array<IAttachments>;
  themes?: Array<IThemes>;
  geopos?: Array<IGeoPos>;
  views?: number;
  pois?: Array<IPoi>;
  approved?: boolean;
  expanded_panel: boolean;
  user_id?: number;

    constructor(obj: IItin = {} as IItin) {
        const {
          id= null,
          itin_name= {},
          short_descr= {},
          description= {},
          trivia= {},
          attachments= [],
          themes= [],
          geopos= [],
          views= 0,
          pois= [],
          approved= false,
          expanded_panel= false,
          user_id= null
        } = obj;

        this.id = id,
        this.itin_name = itin_name,
        this.short_descr = short_descr,
        this.description = description,
        this.trivia = trivia,
        this.attachments = attachments,
        this.themes = themes,
        this.geopos = geopos,
        this.views = views,
        this.pois = pois,
        this.approved = approved,
        this.expanded_panel = expanded_panel,
        this.user_id = user_id;
    }

    static from(obj): IItin {
      return new Itin({
        id : obj.id,
        itin_name : {
          it: obj.name_it,
          sl: obj.name_sl,
          en: obj.name_en
        },
        short_descr : {
          it: obj.short_descr_it,
          sl: obj.short_descr_sl,
          en: obj.short_descr_en
        },
        description : {
          it: obj.description_it,
          sl: obj.description_sl,
          en: obj.description_en
        },
        trivia : {
          it: obj.curiosita_it,
          sl: obj.curiosita_sl,
          en: obj.curiosita_en
        },
        attachments : Attachments.fromArray(obj.attachments),
        themes : Themes.fromArray(obj.thematicpaths),
        geopos : GeoPos.fromArray(obj.geographicalpos),
        views : obj.views,
        pois : Poi.fromArray(obj.pois),
        approved : obj.approved,
        expanded_panel : false,
        user_id : obj.user_id
      });
  }
  static fromArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(Itin.from).filter(item => item != null);
  }

  static to(obj) {
    return {
      id : obj.id,
      name_it : obj.itin_name.it,
      name_sl : obj.itin_name.sl,
      name_en : obj.itin_name.en,
      short_descr_it : obj.short_descr.it,
      short_descr_sl : obj.short_descr.sl,
      short_descr_en : obj.short_descr.en,
      description_it : obj.description.it,
      description_sl : obj.description.sl,
      description_en : obj.description.en,
      curiosita_it : obj.trivia.it,
      curiosita_sl : obj.trivia.sl,
      curiosita_en : obj.trivia.en,
      views : obj.views,
      approved : obj.approved,
      user_id : obj.user_id,
      attachments : Attachments.toArray(obj.attachments),
      thematicpaths : Themes.toArray(obj.themes),
      geographicalpos : GeoPos.toArray(obj.geopos),
      pois: Poi.toArray(obj.pois)
    };
  }
  static toArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(Itin.to).filter(item => item != null);
  }
}
